import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class InterceptorMessageService {

    constructor() { }

    public isLoading = new BehaviorSubject(false);
    public api404Error = new BehaviorSubject(false);
    public generalError = new BehaviorSubject(false);
    public apiNetworkError = new BehaviorSubject(false);
}
